<template>
  <div></div>
</template>

<script>
export default {
  name: 'MenuMode'
}
</script>
